import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export const url = "/v1/useraccount";

export interface PositionInfoI {
  id: number,
  code_type: string,
  area_id: string,
  area_name: string,
  pool_id: string,
  pool_name: string,
  department: string,
  job_title: string,
  job_id: number,
  is_active: boolean,
  flow_approval_info?: {
    id: number,
    approval_code: string,
    approval_number: number,
    department: string,
    job_title: string,
    job_flow: string,
    is_pa: boolean
  }
  segments_info: {
    code_segment: string,
    desc_segment: string
  },
}

export interface IGetUserAccountResponse {
  id: number,
  employee_id: string,
  employee_name: string,
  employee_email: string,
  client_name: string,
  isActive: boolean,
  position_info: PositionInfoI[],
}

export type IUser = Omit<IGetUserAccountResponse, "position_info" | "client_name">
export interface IUserResponse {
  user: Array<IUser>,
  metadata: {
    page: number,
    page_size: number,
    total_items: number,
    total_pages: number
  }
}

export interface IUserAccount extends Omit<IGetUserAccountResponse, "position_info"> {
  create_by: string
}

export interface IGetUserAccountParams {
  page_number?: number;
  page_size?: number;
  search: string;
}

const getUserAccount = async (
  email: string,
): Promise<IGetUserAccountResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/userpositionemail/${email}`,
    method: "GET",
  });

  return data;
};

const getMasterUserAccountList = async (params: IGetUserAccountParams) => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${url}/active`,
    params,
  });
  return response.data;
};

const getAllUserAccount = async (search: string) => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${url}/nonactive`,
    params: { search },
  });
  return response.data;
};

const getUser = async (search: string) => {
  const res = await axiosCashJournalClient.request<IUserResponse>({
    method: "GET",
    url: `${MIDDLE_URL}${url}`,
    params: { search },
  });
  return res.data;
};

const addMasterUserAccount = async (payload: Omit<IUserAccount, "id">) => {
  const response = await axiosCashJournalClient.request({
    method: "POST",
    url: `${MIDDLE_URL}${url}`,
    data: payload,
  });
  return response.data;
};

const deleteMasterUserAccount = async (params: { employee_id: string; update_by: string }) => {
  const response = await axiosCashJournalClient.request({
    method: "DELETE",
    url: `${MIDDLE_URL}${url}`,
    params,
  });
  return response.data;
};

export {
  getUserAccount,
  getMasterUserAccountList,
  getAllUserAccount,
  addMasterUserAccount,
  deleteMasterUserAccount,
  getUser,
};
